import useCan from "../components/users/permissions/useCan";
import useUser from "./useUser";

// Scanning needs an operator: an account without one, or a super admin who has not picked one, is
// refused by every boarding endpoint.
const useCanScan = () => {
  const { user } = useUser();
  return useCan("reservation.ticket.scan") && Boolean(user?.operator?.id);
};

export default useCanScan;
